import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchBillingPolicy = createAsyncThunk(
  'policy/fetchBillingPolicy',
  async (_, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/billing/subscription/policy',
      method: 'GET'
    })

    if (!success) {
      return rejectWithValue(response)
    }
    return response
  }
)
